module.exports = __webpack_public_path__ + "img/skincareMom_g.e5946fff.png";